import React from 'react';
import { H3 } from '../Element/Heading';
import FullWidthStateForm from '../LeadForm/FullWidthStateForm';

interface PurchaseOptionSectionProps {
  state: string;
  cid: string;
}

const PurchaseOptionSection: React.FC<PurchaseOptionSectionProps> = ({
  state,
  cid,
}) => {
  return (
    <>
      <div>
        <H3>Home Solar Financing in {state}</H3>
        <p>
          There are three pathways to powering your home with solar energy in{' '}
          {state}: purchasing the solar system outright, obtaining a loan for
          its financing, or opting for a leasing program. Solar systems can be
          financed by bank loans, solar installer financing, new home mortgages,
          energy loans and home equity loans or lines of credit. Cash works too.
          Regardless of your choice, solar panels can reduce your home energy
          expenses, contributing to financial savings and a cleaner power
          supply. Our Energy Advisors can guide you to the best solar deals in{' '}
          {state}. Here&apos;s a comparison:
        </p>
        <H3>Solar Purchase</H3>
        <ul>
          <li>Optimal Return-On-Investment</li>
          <li>Potential Reduction of Bills to near $0</li>
          <li>Enhances Property Value</li>
        </ul>
        <p>
          <strong>Outright Solar Purchase:</strong> Homeowners with a stronger
          financial position often cover the full cost of solar upfront,
          yielding the highest return-on-investment over the system&apos;s
          lifespan. By paying in cash, homeowners in {state} can claim tax
          credits and rebates, avoid interest charges, and directly enjoy the
          savings on their electricity bills. Some of our customers experience
          virtually no electricity expenses from the moment they install solar.
          We offer top-tier products at attractive cash prices.
        </p>
        <H3>Solar Loan</H3>
        <ul>
          <li>No Initial Expenses</li>
          <li>Ownership of the System</li>
          <li>Appreciates Property Value</li>
        </ul>
        <p>
          <strong>Solar Loan Financing:</strong> Utilizing a solar loan enables
          you to save and own your solar system, as our financiers cover the
          upfront expenses (similar to an auto loan). Homes equipped with solar
          systems command higher value due to their lower operational costs.
          Depending on the chosen solar loan, you can achieve greater monthly
          savings or complete your financing earlier. Our team will help you
          secure the most favorable rates and terms to match your requirements.
          To learn about our latest offerings, connect with us
        </p>
        <H3>Solar Lease</H3>
        <ul>
          <li>No Initial Investment Required </li>
          <li>Complete Maintenance Coverage</li>
          <li>Lower Monthly Payments</li>
          <li>Guaranteed Rates</li>
        </ul>
        <p>
          <strong>Solar Leasing:</strong> Leasing solar panels provides an
          accessible and cost-effective path to solar adoption. With zero
          upfront costs—often referred to as &ldquo;$0 down solar
          financing&ldquo;—installation and maintenance are entirely managed,
          and your home benefits from the energy generated by the solar panels.
          You pay a consistent monthly fee and save compared to your existing
          electricity bill. The reduced electricity rate are what many
          homeowners like about this option.
        </p>
        <p>
          Talk to your EnergyPal Advisor about financing solar options in{' '}
          {state}. We regularly source the best deals and terms for our
          customers. Let us guide you through the finance and application
          process from A-Z.
        </p>
      </div>
      <FullWidthStateForm cid={cid} state={state} />
    </>
  );
};

export default PurchaseOptionSection;
